import {NgModule} from '@angular/core';
// import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '@shared/shared.module';
import {QRCodeModule} from 'angularx-qrcode';
// import {TranslateModule} from '@ngx-translate/core';

import {
  CanhTacComponent,
  CanhTacDetailComponent,
  CanhTacDialogComponent,
  canhTacRoute,
  HanhDongComponent,
} from './';

import {
  CanhTacMgmtDeleteDialogComponent,
  CanhTacMgmtDeletePopupComponent,
} from '@entities/canh-tac/canh-tac-delete-dialog/canh-tac-delete-dialog.component';
import {CanhTacPopupComponent} from '@entities/canh-tac/canh-tac-dialog/canh-tac-dialog.component';
import {TimelineComponent} from '@entities/canh-tac/timeline/timeline.component';
// Gallery and Lightbox modules are provided by SharedModule
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {
  CanhTacExportfileDialogComponent,
  CanhTacExportFilePopupComponent,
} from '@entities/canh-tac/canh-tac-exportfile-dialog/canh-tac-exportfile-dialog.component';
import {
  CanhTacMgmtDeletePersonDialogComponent,
  CanhTacMgmtDeletePersonPopupComponent,
} from '@entities/canh-tac/canh-tac-manager-dialog/canh-tac-delete-person-dialog/canh-tac-delete-person-dialog.component';
import {
  CanhTacManagerDialogComponent,
  CanhtacManagerPopupComponent,
} from '@entities/canh-tac/canh-tac-manager-dialog/canh-tac-manager-dialog/canh-tac-manager-dialog.component';
// QRCodeModule is provided by SharedModule
import {HanhDongGuideLineComponent} from '@entities/canh-tac/hanh-dong-guide-line/hanh-dong-guide-line.component';
import {HoatDongCanhTacComponent} from '@entities/canh-tac/hoat-dong-canh-tac/hoat-dong-canh-tac.component';
import {LichSuQrCodeComponent} from '@entities/canh-tac/lich-su-qr-code/lich-su-qr-code.component';

const ENTITY_STATES = [...canhTacRoute];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QRCodeModule,
    RouterModule.forChild(ENTITY_STATES as Routes),
    MatSlideToggleModule,
    // TranslateModule is already imported in AppModule and can be used via SharedModule if needed
  ],
  declarations: [
    CanhTacComponent,
    CanhTacDetailComponent,
    CanhTacDialogComponent,
    CanhTacPopupComponent,
    CanhTacMgmtDeletePopupComponent,
    CanhTacMgmtDeleteDialogComponent,
    TimelineComponent,
    HanhDongComponent,
    CanhTacExportfileDialogComponent,
    CanhTacExportFilePopupComponent,
    CanhTacManagerDialogComponent,
    CanhtacManagerPopupComponent,
    CanhTacMgmtDeletePersonDialogComponent,
    CanhTacMgmtDeletePersonPopupComponent,
    HanhDongGuideLineComponent,
    HoatDongCanhTacComponent,
    LichSuQrCodeComponent,
  ],
  entryComponents: [
    CanhTacDialogComponent,
    CanhTacPopupComponent,
    CanhTacMgmtDeletePopupComponent,
    CanhTacMgmtDeleteDialogComponent,
    TimelineComponent,
    HanhDongComponent,
    CanhTacExportfileDialogComponent,
    CanhTacExportFilePopupComponent,
    CanhTacManagerDialogComponent,
    CanhtacManagerPopupComponent,
    CanhTacMgmtDeletePersonDialogComponent,
    CanhTacMgmtDeletePersonPopupComponent,
  ],
})
export class CanhTacModule {}
